import { motion } from "framer-motion";
import { useContext, useState } from "react";
import { AuthContext } from "../../hooks/context/Context";
import { useSelector } from "react-redux";
import { selectUserInformations } from "../../features/authSlice";
import NotificationComponent from "../Notifications/NotificationComponent";
import NotificationBell from "../../assets/svg/NotificationBell.svg";
import LogoWrites from "../../assets/svg/LogoWords.svg";
import SearchIcon from "../../assets/svg/Search.svg";
import Dropdown from "./DropdownAvatar/Dropdown";
import { getUnClickedNotification } from "../../features/notifications/notificationSlice";
import useResponsive from "../../hooks/useResponsive";

const NavBar = () => {
  const { menuOpen, setMenuOpen, isCollapsed } = useContext(AuthContext);
  const [openBell, setOpenBell] = useState(false);
  const [avatarDropdown, setAvatarDropdown] = useState(false);
  const user = useSelector(selectUserInformations);
  const unClickedNotifications = useSelector(getUnClickedNotification);
  const { expanded, collapsed, isDesktop, windowWidth } = useResponsive();
  const currentSidebarWidth = isCollapsed ? collapsed : expanded;

  return (
    <motion.div
      className="fixed top-0 left-0 lg:left-[var(--sidebar-width)] right-0 h-16 bg-primary shadow-md sl:h-20 ll:h-24 z-40"
      animate={{
        // Only animate for desktop screens
        // left: window.innerWidth >= 1024 ? `var(--sidebar-width)` : '0',
        left: isDesktop ? currentSidebarWidth : 0,
        transition: { type: "spring", stiffness: 300, damping: 20 }
      }}
    >
      <div className="flex h-full items-center justify-between px-4 lg:px-8 max-w-screen mx-auto">
        {/* Left Section */}
        <motion.div className="flex items-center gap-4">
          <button
            onClick={() => setMenuOpen(true)}
            className="lg:hidden text-white"
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <motion.img
            src={LogoWrites}
            className="h-8 sl:h-24 sl:w-24 ll:h-32 ll:w-32"
            alt="Company Logo"
            whileHover={{ scale: 1.1, rotate: -10 }}
          />
        </motion.div>

        {/* Search Bar - Hidden on mobile */}
        {/* <motion.div className="hidden lg:flex flex-1 max-w-2xl mx-8"
          animate={{
            maxWidth: isDesktop ? (isCollapsed ? "600px" : "300px") : 0,
            opacity: isDesktop ? 1 : 0
          }}
        >
          <div className="relative w-full">
            <img
              src={SearchIcon}
              className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5"
              alt="Search"
            />
            <input
              className="w-full h-12 pl-12 rounded-lg bg-white/20 text-white placeholder-white/80 focus:ring-2 focus:ring-white"
              type="text"
              placeholder="Search..."
            />
          </div>
        </motion.div> */}

        {/* Right Section */}
        <div className="flex items-center gap-8 lg:gap-10">
          <motion.div
            className="relative cursor-pointer"
            whileHover={{ scale: 1.05 }}
          >
            <img
              src={NotificationBell}
              className="h-6 w-6 lg:h-8 lg:w-8"
              onClick={() => {
                setOpenBell(!openBell);
                setAvatarDropdown(false);
              }}
              alt="Notifications"
            />
            {!openBell && unClickedNotifications > 0 && (
              <motion.div className="absolute -top-2 -right-2 bg-red-500 text-xs text-white rounded-full w-6 h-6 flex items-center justify-center"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: "spring" }}
              >
                {unClickedNotifications}
              </motion.div>
            )}
            {openBell && <NotificationComponent openBell={openBell} setOpenBell={setOpenBell} />}
          </motion.div>

          <motion.div className="relative"
            animate={{
              scale: isDesktop ? 1 : 0.9
            }}
          >
            <button
              onClick={() => {
                setAvatarDropdown(!avatarDropdown);
                setOpenBell(false);
              }}
              className="border-2 border-sky-400 rounded-full hover:ring-2"
              style={{
                width: isDesktop ? "48px" : "32px",
                height: isDesktop ? "48px" : "32px"
              }}
            >
              <img
                src={user.image_url}
                className="w-full h-full rounded-full object-cover"
                alt="User Avatar"
              />
            </button>
            {avatarDropdown && <Dropdown setAvatarDropdown={setAvatarDropdown} />}
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default NavBar;

// import React, { useState, useContext } from "react";
// import { useSelector } from "react-redux";
// import { selectUserInformations } from "../../features/authSlice";
// import NotificationComponent from "../Notifications/NotificationComponent";
// import NotificationBell from "../../assets/svg/NotificationBell.svg";
// import LogoWrites from "../../assets/svg/LogoWords.svg";
// import SearchIcon from "../../assets/svg/Search.svg";
// import ActiveNav from "../../assets/svg/ActiveNav.svg";
// import Dropdown from "./DropdownAvatar/Dropdown";
// import { getUnClickedNotification } from "../../features/notifications/notificationSlice";
// import { AuthContext } from "../../hooks/context/Context";

// const NavBar = () => {
//   const [openBell, setOpenBell] = useState(false);
//   const [avatarDropdown, setAvatarDropdown] = useState(false);
//   const user = useSelector(selectUserInformations);
//   const unClickedNotifications = useSelector(getUnClickedNotification);
//   const { menuOpen, setMenuOpen } = useContext(AuthContext);

//   return (
//     <div className={`fixed top-0 left-0 sl:left-[94px] ll:left-[var(--sidebar-width)] right-0 h-[70px] sl:h-[93px] bg-primary p-4 sl:p-6 flex items-center justify-between z-40`}>
//       {/* Left side: Mobile hamburger and Logo */}
//       <div className="flex items-center space-x-3 sl:space-x-4">
//         <button onClick={() => setMenuOpen(true)} className="sl:hidden pr-2 text-white">
//           <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
//           </svg>
//         </button>
//         <img className="w-[100px] sl:w-[130px] ll:w-[150px] h-auto" src={LogoWrites} alt="Logo Words" />
//       </div>

//       {/* Search bar – visible only on large screens */}
//       <div className="hidden sl:flex items-center flex-1 mx-4 sl:mx-6 ll:mx-8 max-w-2xl ll:max-w-3xl">
//         <img className="absolute w-5 h-5 sl:w-6 sl:h-6 ml-4" src={SearchIcon} alt="Search Icon" />
//         <input
//           className="w-full h-12 sl:h-14 ll:h-[55px] pl-12 sl:pl-14 text-base sl:text-lg rounded-lg"
//           type="text"
//           name="globalSearch"
//           placeholder="Search in L-V"
//         />
//       </div>

//       {/* Right section – Notification Bell and Avatar */}
//       <div className="flex items-center space-x-6 sl:space-x-8 ll:space-x-10">
//         <div className="relative">
//           <img
//             className="w-6 h-7 sl:w-7 sl:h-8 ll:w-8 ll:h-9"
//             src={NotificationBell}
//             onClick={() => {
//               setOpenBell(!openBell);
//               setAvatarDropdown(false);
//             }}
//             alt="Notifications"
//           />
//           {!openBell && (
//             <div className="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-red-500 border-2 border-white rounded-full -top-2 -right-2">
//               {unClickedNotifications}
//             </div>
//           )}
//           {openBell && <NotificationComponent openBell={openBell} setOpenBell={setOpenBell} />}
//         </div>

//         <div className="relative">
//           <button
//             className="border-2 border-white rounded-full w-10 h-10 sl:w-12 sl:h-12 ll:w-14 ll:h-14"
//             onClick={() => {
//               setAvatarDropdown(!avatarDropdown);
//               setOpenBell(false);
//             }}
//           >
//             <img className="rounded-full object-cover"
//               src={user.image_url} alt="Avatar" />
//           </button>
//           {avatarDropdown && <Dropdown setAvatarDropdown={setAvatarDropdown} />}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NavBar;